import { Sidebar } from "../components/Sidebar.jsx";
import { DateRangePicker } from "../components/DateRangePicker.jsx";

/**
 * Top-level dashboard chrome: sidebar (left) + header + scrollable main area.
 *
 * Props:
 *   pages        : from @prism/shared/modules — pagesForSources(client.dataSources)
 *   activePage   : string                     — the current page key
 *   onNavigate   : (pageKey) => void
 *   client       : ClientShape
 *   syncStatus   : { sources?, recentLogs? } — fresh per-source status, forwarded to Sidebar
 *   pageTitle    : string
 *   pageSubtitle : string (optional)
 *   showDatePicker : boolean (default true) — Account page hides it since it's not a dashboard
 *   children     : ReactNode                 — page body
 */
export function DashboardLayout({
  pages,
  activePage,
  onNavigate,
  client,
  syncStatus,
  pageTitle,
  pageSubtitle,
  showDatePicker = true,
  children,
}) {
  return (
    <div className="flex h-screen bg-app-bg text-text-primary">
      <Sidebar
        pages={pages}
        activePage={activePage}
        onNavigate={onNavigate}
        client={client}
        syncStatus={syncStatus}
      />
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="bg-surface border-b border-border-default px-6 py-4 flex items-end justify-between gap-4 flex-shrink-0">
          <div className="min-w-0">
            <h1 className="text-[18px] font-semibold leading-tight truncate">
              {pageTitle}
            </h1>
            {pageSubtitle && (
              <div className="text-[11px] text-text-muted mt-0.5 truncate">
                {pageSubtitle}
              </div>
            )}
          </div>
          {showDatePicker && (
            <div className="flex-shrink-0">
              <DateRangePicker />
            </div>
          )}
        </header>
        <main className="flex-1 overflow-y-auto px-6 py-5">{children}</main>
      </div>
    </div>
  );
}
